import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isCustomerLoggedIn } from '../utils/auth';

interface CustomerProtectedRouteProps {
  element: JSX.Element;
}

const CustomerProtectedRoute: React.FC<CustomerProtectedRouteProps> = ({ element }) => {
  const location = useLocation();

  if (!isCustomerLoggedIn()) {
    // Redirect to login, preserving the intended destination
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return element;
};

export default CustomerProtectedRoute;
